export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9804.ae94b5d5.jpg";